import { Link } from "@/i18n/navigation";

const PricingAskInquiry = () => {
  return (
    <div className="mt-[44px] flex w-full flex-col items-center justify-center break-keep rounded-lg bg-primary px-[28px] pb-[32px] pt-[42px]">
      <h2
        className={
          "text-center text-title1 font-[600] text-white sm:text-left sm:text-heading3"
        }
      >
        어떤 요금제가 우리 회사에 맞는지 궁금하신가요?
      </h2>
      <p
        className={
          "mt-[16px] text-center text-body1 text-white sm:mt-0 sm:text-left sm:text-title2 sm:font-[600]"
        }
      >
        도입문의를 남겨주시면 빠르게 연락드리겠습니다.{" "}
      </p>
      <Link
        className="mt-[20px] flex h-[40px] w-[144px] items-center justify-center rounded-md bg-white font-[600] text-primary sm:mt-[30px] sm:w-[152px]"
        href={"/inquiry"}
      >
        도입문의
      </Link>
    </div>
  );
};

export default PricingAskInquiry;
